// This file is generated by pnpm icons:generate. Do not edit.

import {RaisingHand4Finger_Stroke2_Corner2_Rounded as CanonicalRaisingHand4Finger_Stroke2_Corner2_Rounded} from './RaisingHand4Finger'

/** @deprecated Import RaisingHand4Finger_Stroke2_Corner2_Rounded from `#/components/icons/RaisingHand4Finger` instead. */
export const RaisingHand4Finger_Stroke2_Corner2_Rounded =
  CanonicalRaisingHand4Finger_Stroke2_Corner2_Rounded
